import { TCustomerField } from 'modules/checkout/domain/entities';
import { IAddress } from 'shared/domain/entities';

export type TAddressOwner = 'address' | 'guardian.address';

export type TAddressLabels = {
  cities: Record<number, string>;
  districts: Record<number, string>;
};

export type TPostalCodeAutofill = {
  updates: Array<[TCustomerField, unknown]>;
  labels: TAddressLabels;
};

export default function getPostalCodeAutofill(
  address: IAddress | undefined,
  owner: TAddressOwner,
  fields: TCustomerField[],
): TPostalCodeAutofill {
  const autofill: TPostalCodeAutofill = {
    updates: [],
    labels: { cities: {}, districts: {} },
  };

  const fill = (path: TCustomerField, value: unknown) => {
    if (fields.includes(path)) autofill.updates.push([path, value]);
  };

  if (address?.street) fill(`${owner}.street`, address.street);

  if (!address?.city?.id) return autofill;

  fill(`${owner}.city.id`, address.city.id);
  autofill.labels.cities[address.city.id] = address.city.name;

  if (address.district?.id) {
    fill(`${owner}.district.id`, address.district.id);
    autofill.labels.districts[address.district.id] = address.district.name;
  }

  return autofill;
}
